import React from 'react'
import { omit, pick, isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Select from '../Select'
import md5 from 'blueimp-md5'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { uploadImage } from '../../store/reducers/profile/uploadImage'
import Input from '../Input'
import { checkEmail, checkPhone} from '../../containers/Signin'
import { getLiteList } from '../../store/reducers/liteFundlist'
import Loader from '../OverlayLoader'
import { getLoggedUser, getIsLogged } from '../../selectors/user.js'
import { sendMindbox, fetchingState } from '../../helpers/hocs.js'
import Button from '../Button'
import { claimAsLot} from '../../store/reducers/auth.js'
import { /*logIn, confirmCode, clearAuthData, clearError,*/ requestCode } from '../../store/reducers/claim'
import Timer from '../SIgn/Timer'

const ClaimForm = ({claim, inputCheck, setFundId, fundArrObj, requestCode, submit, success, fetching,
  intl, setInput, errors, tmpData, months, proceed, upload, imagesState = {}, images, imageRemove, lightVersion, 
  clearAuthData, stateError, code, setCode, setHelper, helper, setSelect, showSubmit, showCodeForm }) => (
    
  <div className="FundForm Become-member__container" /*style={{backgroundColor: '#ff5027'}}*/>
    <h1 className='Head GiftCardsBuy__row-xl' style={{color: '#ff5027'}}>
      {!success ? <FormattedMessage id='claim.become_participant' /> : <FormattedMessage id='claim.application_accepted' />}
    </h1>
    {!success && (
      <Loader loading={fetching} isOrange>
        <div className='modal__form modal__form_claim Become-member__form-wrapper'>
          <div className='Become-member__side Become-member__left'>
            <div className='Become-member__input-group'>
              <Input 
                name='name' 
                onChange = {setInput('name')} 
                errors = {errors} 
                value = {tmpData.name}
                label={'Имя*'}
              />
              <Input 
                name='surname' 
                onChange = {setInput('surname')} 
                errors = {errors} 
                value = {tmpData.surname}
                label={'Фамилия*'}
              />
            </div>
            <div className='Become-member__input-group'>
              <Input 
                name='middlename' 
                onChange = {setInput('middlename')} 
                errors = {errors} 
                value = {tmpData.middlename}
                label={'Отчество'}
              />

              <Select
								items={{"male": "Мужской", "female": "Женский"}}
								value={tmpData.gender}
								onSubmit={setSelect("gender")}
								class="Select_theme_block Select_theme_gray Select_theme_absolute"
								required
								placeholder="Пол*"
							/>
            </div>
            <div className='Become-member__input-group'>
            <Input 
              type='number'
              name='birthday' 
              onChange = {setInput('birthday')} 
              errors = {errors} 
              value = {tmpData.birthday}
              min = {1}
              max = {31}
              label={'День рождения*'}
            />
            <Select 
                class="Select Select_theme_block Select_theme_gray Select_theme_absolute"
                placeholder={intl.formatMessage({id: 'profile_edit.month'})} 
                value={tmpData.birthmonth}
                items={months} 
                onSubmit={proceed.bind(this, 'birthmonth')} 
                required 
              />

            </div>

            <div className='Become-member__input-group'>
              <Input
                type='tel'
                name='phone' 
                onChange = {setInput('phone')} 
                errors = {errors} 
                value = {tmpData.phone}
                label={'Телефон*'}
              />
              <Input 
                type='email'
                name='email' 
                onChange = {setInput('email')} 
                errors = {errors} 
                value = {tmpData.email}
                label={'Email*'}
              />
            </div>

            <div className="Become-member__agreement">
              <label className='Become-member__agreement-container'>
                <input type='checkbox' name='offerCheckbox' onClick={() => {setHelper(!helper)}}/> 
                <div className='Become-member__agreement-checkbox'>
                  <div className='Become-member__agreement-checkbox-arrow'></div>
                </div>
                <span className='Become-member__agreement-text' style={{color: "black"}}>Связь с помощником</span>
              </label>
            </div>

            {helper && <div className='Become-member__input-group'>
             
              <Input 
                type='text'
                name='helpername' 
                onChange = {setInput('helpername')} 
                errors = {errors} 
                value = {tmpData.helpername}
                label={'Имя помощника*'}
              />
              <Input
                type='tel'
                name='helperphone' 
                onChange = {setInput('helperphone')} 
                errors = {errors} 
                value = {tmpData.helperphone}
                label={'Телефон помощника*'}
              />
             
            </div>
            }

            {!lightVersion && (<div><Input 
              name='birthday' 
              onChange = {setInput('birthday')} 
              errors = {errors} 
              value = {tmpData.birthday}
              label={'День рождения*'}
            />
            <br></br></div>)}

            {!lightVersion && (<div><div className="FundForm_field FundForm_field_background">
              <Select class="GiftCardsBuy__Select GiftCardsBuy__Select__claim Member-anketa__selectWrapper"
                classname="GiftCardsBuy__select Member-anketa__select"
                scrollclass="GiftCardsBuy-scroll GiftCardsBuy-scroll__claim"
                classItem="GiftCardsBuy__Select-item Member-anketa__selectItem"
                placeholder={intl.formatMessage({id: 'profile_edit.month'})} 
                value={tmpData.birthmonth}
                items={months} 
                onSubmit={proceed.bind(this, 'birthmonth')} 
                required 
              />
            </div>
            <br></br><br></br></div>)}

            <Input 
              name='job' 
              onChange = {setInput('job')} 
              errors = {errors} 
              value = {tmpData.job}
              label={'Должность*'}
            />
            <Input 
              name='company' 
              onChange = {setInput('company')} 
              errors = {errors} 
              value = {tmpData.company}
              label={'Компания'}
            />
            <Input
              type='textarea'
              name='articles' 
              onChange = {setInput('articles')} 
              errors = {errors} 
              value = {tmpData.articles}
              label={'Ссылки на социальные медиа и статьи'}
              //minRows={11}
              isTextarea
              height="100%"
            />
          </div>
          <div className='Become-member__side Become-member__right'>
            <Input
              type='textarea'
              name='description' 
              onChange = {setInput('description')} 
              errors = {errors} 
              value = {tmpData.description}
              label={'Биография (500-1200 символов)*'}
              //minRows={10}
              isTextarea
              length={tmpData.description? tmpData.description.length : 0}
              minLength={500}
              maxLength={1200}
              height="300px"
            />

            <div className="Become-member__agreements">
              <label className='Become-member__agreement-container'>
                <input type='checkbox' name='agreementProcessingCheckbox' onChange={inputCheck(this)} />
                <div className='Become-member__agreement-checkbox'>
                  <div className='Become-member__agreement-checkbox-arrow'></div>
                </div>
                <span className='Become-member__agreement-text' style={{color: "black"}}>
                  Даю
                  {' '}
                  <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/agreement_processing_offer_lot.pdf' style={{textDecoration: "underline"}}>
                    согласие
                  </a>
                  {' '}
                  на обработку указанных персональных данных в целях участия в мероприятиях, проводимых в рамках
                  {' '}
                  <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
                    Программы Meet For Charity
                  </a>
                </span>
              </label>
              {errors && errors.agreementProcessingCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}

              <label className='Become-member__agreement-container'>
                <input type='checkbox' name='agreementDistributionCheckbox' onChange={inputCheck(this)} />
                <div className='Become-member__agreement-checkbox'>
                  <div className='Become-member__agreement-checkbox-arrow'></div>
                </div>
                <span className='Become-member__agreement-text' style={{color: "black"}}>
                  Даю
                  {' '}
                  <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/agreement_distribution_offer_lot.pdf' style={{textDecoration: "underline"}}>
                    согласие
                  </a>
                  {' '}
                  на распространение персональных данных</span>
              </label>
              {errors && errors.agreementDistributionCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}
            </div>

          {/*<Input  
            name='instagram' 
            onChange = {setInput('instagram')} 
            errors = {errors} 
            value = {tmpData.instagram}
            label={'Аккаунт в Instagram'}
            startValue={'instagram.com/'}
          />
          <br></br>

          <Input  
            name='facebook' 
            onChange = {setInput('facebook')} 
            errors = {errors} 
            value = {tmpData.facebook}
            label={'Страница в Facebook'}
            startValue={'facebook.com/'}
          />
          <br></br>*/}

          {!lightVersion && (<div><div className={"FundForm_field FundForm_field_background" + (errors.fundId ? ' _error' : "")}>
            <Select class="GiftCardsBuy__Select GiftCardsBuy__Select__claim Member-anketa__selectWrapper"
              classname="GiftCardsBuy__select Member-anketa__select"
              scrollclass="GiftCardsBuy-scroll GiftCardsBuy-scroll__claim"
              classItem="GiftCardsBuy__Select-item Member-anketa__selectItem"
              placeholder={'Фонд'} 
              value={tmpData.fundId}
              items={fundArrObj} 
              onSubmit={setFundId} 
              required 
            />
          </div>
          {errors.fundId && <div className="FundForm FundForm_error">Обязательное поле</div>}
          <br></br></div>)}

          {!lightVersion && (<div><Input
            type='textarea'
            name='visitsDates' 
            onChange = {setInput('visitsDates')} 
            errors = {errors} 
            value = {tmpData.visitsDates}
            label={'Даты встреч в ближайшее время'}
            //minRows={10}
            isTextarea
          />
          <br></br></div>)}
          { lightVersion && (
            <div>
              <div className='modal__photos'>
                <label className='Button Button_black modal__photos-label modal__fullWidth' style={{marginTop: 0}}>
                  <input className='modal__photos-field' type='file' multiple onChange={upload} />
                  <FormattedMessage id='profile_report.add_photo' />
                </label>

                <div className='modal__photos-preview' style={{paddingTop: 20}}>
                  {Object.keys(imagesState).map(key => (
                    <div className='modal__photos-preview-item' key={key}>
                      { (imagesState[key] < 100 ||  !images || !images[key])
                        ? <Loader isLight />
                        : (
                          <div className='modal__photos-preview-img'>
                            <img src={images[key].url} alt={images[key].name} className='' />
                            <span className='modal__photos-preview-overlay Text' onClick={imageRemove.bind(this, key)}>
                              <span className='modal__photos-preview-overlay__after'>
                                {intl.formatMessage({id: 'profile_report.delete_photo'})}
                              </span>
                            </span>
                          </div>
                        )
                      }
                    </div>
                  ))}
                </div>
              </div>

              <div className="Become-member__agreements">
                <label className='Become-member__agreement-container'>
                  <input type='checkbox' name='agreementPhotoCheckbox' onChange={inputCheck(this)} />
                  <div className='Become-member__agreement-checkbox'>
                    <div className='Become-member__agreement-checkbox-arrow'></div>
                  </div>
                  <span className='Become-member__agreement-text' style={{color: "black"}}>
                    Даю
                    {' '}
                    <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/agreement_photo_offer_lot.pdf' style={{textDecoration: "underline"}}>
                      согласие
                    </a>
                    {' '}
                    на безвозмездное использование моих изображений
                  </span>
                </label>
                {errors && errors.agreementPhotoCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}

                <label className='Become-member__agreement-container'>
                  <input type='checkbox' name='mailingCheckbox' onChange={inputCheck(this)} />
                  <div className='Become-member__agreement-checkbox'>
                    <div className='Become-member__agreement-checkbox-arrow'></div>
                  </div>
                  <span className='Become-member__agreement-text' style={{color: "black"}}>
                    Согласен получать информационное оповещение о деятельности, инициативах и мероприятиях, проводимых в рамках
                    {' '}
                    <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
                      Программы Meet For Charity
                    </a>
                  </span>
                </label>
                {errors && errors.mailingCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}

                <label className='Become-member__agreement-container'>
                  <input type='checkbox' name='acceptingCheckbox' onChange={inputCheck(this)} />
                  <div className='Become-member__agreement-checkbox'>
                    <div className='Become-member__agreement-checkbox-arrow'></div>
                  </div>
                  <span className='Become-member__agreement-text' style={{color: "black"}}>
                    Нажимая далее, я принимаю условия
                    {' '}
                    <a target='_blank' rel='noopener noreferrer' href='/offer' style={{textDecoration: "underline"}}>
                      Пользовательского соглашения,
                    </a>
                    {' '}
                    <a target='_blank' rel='noopener noreferrer' href='/assets/files/docs/05.pdf' style={{textDecoration: "underline"}}>
                      Программы Meet For Charity,
                    </a>
                    {' '}
                    и соглашаюсь с
                    {' '}
                    <a target='_blank' rel='noopener noreferrer' href='/policy' style={{textDecoration: "underline"}}>
                      Политикой конфиденциальности
                    </a>
                  </span>
                </label>
                {errors && errors.acceptingCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}
              </div>
            </div>
          )}
          {/* submit */}
            { !showSubmit ?
              <div>
                <Button theme="orange w100" onClick={() => showCodeForm()}>
                  <FormattedMessage id='sign_in.send_confirmation_code' />
                </Button>
                {(stateError) && <div className='Text'>{stateError}</div>}
              </div>
              :
              <div>
                <Input
                  name='confirmCode'
                  onChange = {e => setCode(e.target.value)} 
                  errors={errors}
                  value = {code}
                  label={'Код подтверждения'}
                />
                <div className='Signin__actions'>
                  {(stateError) && <div className='Text'>{stateError}</div>}
                  { showSubmit && <Timer clear={clearAuthData} sendCode={() => requestCode(tmpData.phone)} noBack /> }
                </div>

                {/*<div className="Become-member__agreement"  style={{marginTop: '10px'}}>*/}
                {/*  <label className='Become-member__agreement-container'>*/}
                {/*    <input type='checkbox' name='offerCheckbox' onChange={inputCheck(this)} />*/}
                {/*    <div className='Become-member__agreement-checkbox'>*/}
                {/*      <div className='Become-member__agreement-checkbox-arrow'></div>*/}
                {/*    </div>*/}
                {/*    <span className='Become-member__agreement-text' style={{ color: "black" }}>Нажимая на кнопку «Отправить», я даю согласие на обработку своих персональных данных и соглашаюсь с условиями <a className='member-anketa-policyLink' target='_blank' rel='noopener noreferrer' href='/policy' style={{ textDecoration: "underline" }}><FormattedMessage id='sign_in.the_privacy_policy' /></a></span>*/}
                {/*  </label>*/}
                {/*</div>*/}
                {/*{errors && errors.offerCheckbox && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}*/}
                
                <Button theme="orange w100" style={{marginTop: '10px'}} onClick={submit}>
                  <FormattedMessage id='claim.send' />
                </Button>
                
              </div>
            }

          {/* submit */}
          </div>
          <div style={{fontSize: "18px", marginLeft: "18px", marginTop: "12px"}}>*обязательное поле для ввода информации</div>
        </div>
        {!isNil(success) && (<div className='Text'><FormattedMessage id='claim.error' /></div>)}
      </Loader>
      
    )}
    
  </div>
)

const mapStateToProps = state =>  ({ isLogged: getIsLogged(state), user: getLoggedUser(state), claim: state.claim, ...state.images, fundArrObj: state.liteFundlist.items, ...state.profile.report})
const mapDispathToProps = dispatch => bindActionCreators({ claimAsLot, uploadImage, getLiteList, requestCode, /*confirmCode, logIn, clearAuthData, clearError*/ }, dispatch)

export default injectIntl(compose(
  fetchingState(),
  connect(mapStateToProps, mapDispathToProps),
  withState('fundId', 'setFundId', null),
  withState('imagesState', 'setImages', {}),  // image
  withState('success', 'setSuccess', null),
  withState('tmpData', 'setTmpData', {}),
  withState('errors', 'setErrors', {}),//ошибки заполнения формы
  withState('months', 'setMonths', {}),
  withState('helper', 'setHelper', false),  
  withState('stateError', 'setStateError', null),
  withState('code', 'setCode', null),
  withState('isActiveButton', 'setIsActiveButton', true),
  withState('showSubmit', 'setShowSubmit', false),

  fetchingState(),
  //fetchingState({ multi: true }),
  withHandlers({
    setInput: ({ setTmpData, tmpData }) => field => e => {//запись данных при записи в input
      if (field === 'birthday' && e.target.value.length > 2) return
      tmpData[field] = e.target.value
      setTmpData(tmpData)
    },
		setSelect: ({ setTmpData, tmpData }) => field => value => {
			tmpData[field] = value
			setTmpData(tmpData)
		},
    inputCheck: ({ setTmpData, tmpData }) => field => e => {
      if (e.target.name == 'isWhite'){
        tmpData['isOrange'] = false//(e.target.checked)
        setTmpData(tmpData)
      } else if (e.target.name == 'isOrange') {
        tmpData['isOrange'] = true
        setTmpData(tmpData)
      } else {
        tmpData[e.target.name] = e.target.checked
        setTmpData(tmpData)
      }
    },

    submit: ({ isLogged, claimAsLot, fundId, helper, fetchingWrap, setSuccess, onSuccess, tmpData, images, imagesState, setImages, setErrors, errors, error, months, user, lightVersion, confirmCode, claim, code, setStateError }) => async e => {
      e && e.preventDefault()
      const data = { ...tmpData, code }
      //if (!data || !data.length || !isLogged) return
      //let result = await fetchingWrap(claimAsLot.bind(this, text))
      images = Object.values(pick(images, Object.keys(imagesState))).map(el => el._id)
      data.images = images;
      data.fund = fundId;
      data._id = claim._id 

      const errors = {};
      if (!data.name) errors.name = true
      if (!data.surname) errors.surname = true
      if (!data.email || !checkEmail(data.email)) errors.email = true
      if (!data.phone || !checkPhone(data.phone)) errors.phone = true
      if (!data.job) errors.job = true
      // if (!data.company) errors.company = true
      if (!lightVersion && !data.images) errors.images = true
      if (!data.description || data.description.length < 500 || data.description.length > 1200) errors.description = true
      if (!lightVersion && (!data.articles || data.articles.length < 10)) errors.articles = true
      if (!lightVersion && !data.fund) errors.fundId = true
      if (!lightVersion && !data.visitsDates) errors.visitsDates = true
      if (!data.agreementProcessingCheckbox) errors.agreementProcessingCheckbox = true
      if (!data.agreementDistributionCheckbox) errors.agreementDistributionCheckbox = true
      if (!data.agreementPhotoCheckbox) errors.agreementPhotoCheckbox = true
      if (!data.mailingCheckbox) errors.mailingCheckbox = true
      if (!data.acceptingCheckbox) errors.acceptingCheckbox = true
      if (helper && !data.helpername) errors.helpername = true
      if (helper && !data.helperphone) errors.helperphone = true
      if (!code) errors.code = true
      //проверка на число и обязательный перевод в число если проверка прошла но есть левый символ
      //который уберется и на сервере все корректно отработало
      if (!data.birthday || isNaN(parseInt(data.birthday))) errors.birthday = true
      else data.birthday = parseInt(data.birthday)

      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        const result = await claimAsLot(data);
        if (result === 200) setSuccess(true)
        else setSuccess(false)


        let mindboxData
            if (user) {
              mindboxData = {
                customer: {
                  email: data.email,
                  lastName: data.surname,
                  firstName: data.name,
                  mobilePhone: data.phone,
                  ids: {
                    websiteID: user._id
                  },
                  customFields: {
                    facebook: data.facebook ? data.facebook : '',
                    post: data.job ? data.job : '',
                    company: data.company ? data.company : '',
                    instagram: data.instagram ? data.instagram : '',
                    birthday: (data.birthmonth && data.birthday) ? `${data.birthday} ${months[data.birthmonth]}` : ''
                  },
                },
                customerAction: {
                  customFields: {
                    dateMeet: data.visitsDates,
                    referencearticle: data.articles,
                    fund: fundId,
                    biography: data.description
                  }
                },
                pointOfContact: "meetforcharity-website"
              }
              sendMindbox(mindboxData, 'claim_autorized')
            } else {
              mindboxData = {
                customer: {
                  email: data.email,
                  lastName: data.surname,
                  firstName: data.name,
                  mobilePhone: data.phone,
                  customFields: {
                    facebook: data.facebook ? data.facebook : '',
                    post: data.job ? data.job : '',
                    company: data.company ? data.company : '',
                    instagram: data.instagram ? data.instagram : '',
                    birthday: (data.birthmonth && data.birthday) ? `${data.birthday} ${months[data.birthmonth]}` : ''
                  },
                },
                customerAction: {
                  customFields: {
                    dateMeet: data.visitsDates,
                    referencearticle: data.articles,
                    fund: fundId,
                    biography: data.description
                  }
                },
                pointOfContact: "meetforcharity-website"
              }

              sendMindbox(mindboxData, 'claim_notautorized')
            }


      }
    },
    showCodeForm: ({setShowSubmit, requestCode, setFormId, claim, tmpData})=> async (f, e) => {
      const {phone} = tmpData
      if (!phone) return
      const res = await requestCode(phone);
      return setShowSubmit(this)
    },
    proceed: ({ setTmpData, tmpData}) => (field, e) => {
      e && e.preventDefault && e.preventDefault()
      tmpData[field] = (e === null) ? e : Number(e)
      setTmpData(tmpData)
    },
    
    upload: ({ setImages, uploadImage, imagesState }) => e => {
      const files = e.target.files
      try {
        for (let i = 0; i < files.length; i++) { // images
          const file = files.item(i)
          imagesState[md5(file.name)] = 0
          setImages(imagesState)
          const onUpload = (e) => {
            imagesState[md5(file.name)] = Math.floor((e.loaded * 100) / e.total)
            setImages(imagesState)
          }
          uploadImage(file, onUpload)
        }
      } catch(e) {
        alert(e)
      }

    },
    imageRemove: ({ setImages, imagesState }) => (key, e) => {
      e && e.preventDefault()
      setImages(omit(imagesState, key))
    },

  }),
  lifecycle({
    componentWillUnmount() { 
      this.props.setSuccess(null)
      this.props.setImages({})
      //this.props.clearAuthData()
    },
    async componentWillMount () {
      await this.props.getLiteList()
      this.props.setSuccess(null)
      //this.props.clearError()
      let months = {null: '\n'}//массив месяцев
      for (let i = 0; i < 12; i++) {
        months[i] = this.props.intl.formatMessage({id: 'profile_edit.birthday.' + i})
      }
      this.props.setMonths(months)
    },
    componentWillReceiveProps (np) {
      //if ((np.claim.loginId !== this.props.claim.loginId) && np.claim.loginId) this.props.requestCode(np.claim.loginId)
    }
  })
)(ClaimForm))



// WEBPACK FOOTER //
// ./src/components/Profile/Claim1.jsx